import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { EventAllDetailsDataState } from '../interface/sportPrematch';

const initialState: EventAllDetailsDataState = {
	backgroundURL: '',
	event: {
		categoryId: 0,
		categoryName: '',
		eventCodeId: 0,
		eventExtendedData: {
			remoteCategoryId: '',
		},
		eventId: 0,
		eventName: '',
		eventStart: 0,
		eventType: 0,
		games: [],
		gamesCount: 0,
		isLive: false,
		marketTypes: [
			{
				gameIds: [],
				marketType: 0,
			},
		],
		parentId: 0,
		parentName: '',
		participants: [
			{
				number: 0,
				participantId: 0,
				participantName: '',
			},
		],
		remoteId: 0,
		sportId: 0,
		sportName: '',
		treatAsSport: 1,
		statScore: 0,
		disableNoFollow: false,
	},
	customeBets: [],
};

const reducer = (state: EventAllDetailsDataState = initialState, action: Action): EventAllDetailsDataState => {
	switch (action.type) {
		case actionTypes.FETCH_EVENT_DETAIL_DATA_SUCCESS:
			return {
				...state,
				event: action.payload.event,
				customeBets: action.payload.customeBets,
			};
		case actionTypes.RESET_EVENT_DETAIL_DATA:
			return initialState;
		default:
			return state;
	}
};

export default reducer;
